<template>
  <div></div>
</template>

<script>
export default {
  name: 'Cooperate',
  created() {
    this.$router.replace({ name: 'CompanyIntroduce', hash: '#customers' })
  }
}
</script>
